import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ViewMembersPanelNew from "../../../../components/view-members-new/view-members-new";
import CMEGroupHeadMemberModal from "./cme-group-head-member-modal";
import ArrowDown from "../../../../assets/icons/ArrowDown.svg";
import ArrowUp from "../../../../assets/icons/ArrowUp.svg";
import ArrowHover from "../../../../assets/icons/ArrowHover.svg";
import { useSortableData } from "../../dashboard-util/dashboard-utils";
import "../../dashboard-cme/dashboard-cme.scss";

const ProjectTable = ({ projects, isDormant }) => {
    const [selectedProject, setSelectedProject] = useState(null);
    const [show, setShow] = useState(false);
    const projectList = isDormant ? projects.Dormant : projects.Active;
    const { items, requestSort, getArrowDirectionFor } = useSortableData(projects);

    const onHide = () => {
        setShow(false);
        setSelectedProject(null);
    };

    const handleShowModal = (project) => {
        setShow(true);
        setSelectedProject(project);
    };

    return (
        <div className='scrollable-dashboard'>
        <table className="CMEDashboardTable">
            <thead className="MemberTableColumnHeader cmeHeader sticky-header-dashboard">
                <tr className="tableColumnTitles tableHeader">
                    {
                        projectList[0]?.ProjectDynamicFields?.map((dynamicColumns, index) => {
                            return (
                                index === 0
                                    ?
                                    <>
                                        <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                                            <div onClick={() => requestSort(isDormant ? "CMEdormant" : "CMEactive")} className={'sortedCenter'}>
                                                <div className="containerTextSorted">
                                                    <p className="textSorted">DEAL</p>
                                                </div>
                                                {getArrowDirectionFor(isDormant ? "CMEdormant" : "CMEactive", "descending") && (
                                                    <img className="arrowDirection" alt="Arrow down" src={ArrowDown} />
                                                )}
                                                {getArrowDirectionFor(isDormant ? "CMEdormant" : "CMEactive", "ascending") && (
                                                    <img className="arrowDirection" alt="Arrow up" src={ArrowUp} />
                                                )}
                                                {getArrowDirectionFor(isDormant ? "CMEdormant" : "CMEactive") && (
                                                    <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover} />
                                                )}
                                            </div>
                                        </th>
                                        <th className="col-md-3 col-sm-3 textEllipsis headerSorted">Project Name</th>
                                    </>
                                    :
                                    <th className="col-md-1 col-sm-1 textEllipsis headerSorted">{dynamicColumns?.Label}</th>
                            );
                        })
                    }
                    <th className="col-md-3 col-sm-3 textEllipsis headerSorted">Members</th>
                    <th className="col-md-3 col-sm-3 textEllipsis headerSorted">Staffer</th>
                    <th className="col-md-3 col-sm-3 textEllipsis headerSorted"># of Associates/Analysts</th>
                    <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Total Hours</th>
                    <th className="col-md-1 col-sm-1 textEllipsis headerSorted">M-F Hours</th>
                    <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Saturday Hours</th>
                    <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Sunday hours</th>
                </tr>
            </thead>
            <tbody className="tableBody cmeBody" data-testid="table-body">
                {projectList.length > 0 &&
                    projectList.map((active) => {
                        return (
                            <tr key={active?.DashboardKey} className={isDormant ? "dormantRow" : ""}>
                                {active?.ProjectDynamicFields?.length > 0 &&
                                    active?.ProjectDynamicFields?.map((d, index) => {
                                        return (
                                            index === 0
                                                ?
                                                <>
                                                    <td className={`col-md-2 col-sm-1 mt-2 hover`}
                                                        onClick={() => handleShowModal(active)}
                                                        data-testid={`group-head-${active.Project?.Id}-${active.Project?.Name}`}
                                                    >
                                                        <div className="violationContainer">
                                                            {d.Data}
                                                        </div>
                                                    </td>
                                                    <td className="col-md-1 col-sm-1 mt-2">
                                                        {active.Project?.Name}
                                                    </td>
                                                </>
                                                :
                                                <td className="col-md-1 col-sm-1 mt-2">
                                                    {d.Data}
                                                </td>
                                        );
                                    })
                                }
                                <td className="col-md-3 col-sm-3 mt-3 cmeMemberColumn">
                                    <ViewMembersPanelNew
                                        UserID={active.Project?.Owner?.Id}
                                        members={active.Project?.Members}
                                        projects={active.Project}
                                        isHidden={true}
                                    />
                                </td>
                                <td className="col-md-3 col-sm-3 mt-3">
                                    {active.Staffer.Name}
                                </td>
                                <td className="col-md-3 col-sm-3 mt-3">
                                    {active.QtyMembers}
                                </td>
                                <td className="col-md-1 col-sm-1 mt-2">
                                    {active.AggregateTotalHours}
                                </td>
                                <td className="col-md-1 col-sm-1 mt-2">
                                    {active.AggregateMFHours}
                                </td>
                                <td className="col-md-1 col-sm-1 mt-2">
                                    {active.AggregateSaturdayHours}
                                </td>
                                <td className="col-md-1 col-sm-1 mt-2">
                                    {active.AggregateSundayHours}
                                </td>                               
                            </tr>
                        );
                    })}
            </tbody>
        </table>
        {selectedProject &&
            <CMEGroupHeadMemberModal item={selectedProject} show={show} onHide={onHide} />
        }
        </div>
    );
};

ProjectTable.propTypes = {
    projects: PropTypes.arrayOf(
        PropTypes.shape({
          Project: PropTypes.shape({
            Id: PropTypes.number.isRequired,
            Name: PropTypes.string.isRequired,
            Owner: PropTypes.shape({
              Id: PropTypes.number.isRequired,
              Name: PropTypes.string.isRequired,
            }).isRequired,
            Members: PropTypes.arrayOf(
              PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Name: PropTypes.string.isRequired,
              })
            ).isRequired,
          }).isRequired,
          ProjectDynamicFields: PropTypes.arrayOf(
            PropTypes.shape({
              Label: PropTypes.string.isRequired,
              Data: PropTypes.string.isRequired,
            })
          ).isRequired,
          ProjectMembers: PropTypes.arrayOf(PropTypes.shape({
            UserId: PropTypes.string,
            IsViolation: PropTypes.bool,
            AnalystAssociate: PropTypes.string,
            MFHours: PropTypes.string,
            SaturdayHours: PropTypes.string,
            SundayHours: PropTypes.string,
            TotalHours: PropTypes.string,
            Workload: PropTypes.string,
            LastUpdated: PropTypes.string
        })),
            AggregateMFHours: PropTypes.string.isRequired,
            AggregateSaturdayHours: PropTypes.string.isRequired,
            AggregateSundayHours: PropTypes.string.isRequired,
            AggregateTotalHours: PropTypes.string.isRequired,
            Description: PropTypes.string.isRequired,
            LastUpdated: PropTypes.string,
            IsViolation: PropTypes.bool.isRequired,
            QtyMembers: PropTypes.number.isRequired,
            Staffer: PropTypes.shape({
              Id: PropTypes.number.isRequired,
              Name: PropTypes.string.isRequired,
            }).isRequired,
        }),
    ),
    isDormant: PropTypes.bool.isRequired,
};

export default ProjectTable;
